import { useMemo } from 'react';
import styled from '@emotion/styled';
import { Info } from 'react-feather';
import { Tooltip } from '@trinity/chat-components/components/presentation/Tooltip';

export type InfoTooltipProps = {
  className?: string;
  iconClassName?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  text: React.ReactNode;
  tooltipStyle?: { [key: string]: unknown };
};

type Props =
  InfoTooltipProps;

export const InfoTooltip = (props: Props) => {

  const placement = useMemo(() => {
    return props.placement
      ? props.placement
      : `right`;
  }, [props.placement]);

  return (
    <Root className={props.className}>
      <Tooltip
        title={props.text}
        placement={placement}>
        <Wrapper>
          <StyledInfoIcon className={props.iconClassName} />
        </Wrapper>
      </Tooltip>
    </Root>
  );
};

const Root = styled.div({

});

const Wrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const StyledInfoIcon = styled(Info)(({ theme }) => ({
  fill: '#f5f5f5',
  stroke: theme.palette.primary.main,
  height: 18,
  width: 18,
}));